export default {
  'projectSettings.detail.title': 'Project Details',
  'projectSettings.detail.subtitle': 'Maintain the current project information',
  'projectSettings.detail.basicInfo': 'Basic Information',
  'projectSettings.detail.unsaved': 'Unsaved changes',
  'projectSettings.detail.refresh': 'Refresh',
  'projectSettings.detail.edit': 'Edit Project',
  'projectSettings.detail.noContext':
    'No project context was found for this page',
  'projectSettings.detail.loadError': 'Failed to load project details',
  'projectSettings.detail.loadErrorHint':
    'Check your connection and try again.',
  'projectSettings.detail.retry': 'Retry',
  'projectSettings.detail.logoPreview': 'Preview',
  'projectSettings.detail.priority': 'Priority',
  'projectSettings.detail.cnName': 'Project Name',
  'projectSettings.detail.name': 'English Name',
  'projectSettings.detail.identifier': 'Project Identifier',
  'projectSettings.detail.prefix': 'Project Prefix',
  'projectSettings.detail.group': 'Project Group',
  'projectSettings.detail.group.none': 'Ungrouped',
  'projectSettings.detail.group.loadError':
    'Failed to load project groups. Try again later.',
  'projectSettings.detail.tags': 'Project Tags',
  'projectSettings.detail.status': 'Project Status',
  'projectSettings.detail.status.initiation': 'Initiation',
  'projectSettings.detail.status.requirements': 'Requirements',
  'projectSettings.detail.status.design': 'Design',
  'projectSettings.detail.status.development': 'Development',
  'projectSettings.detail.status.testing': 'Testing',
  'projectSettings.detail.status.launched': 'Launched',
  'projectSettings.detail.status.maintenance': 'Maintenance',
  'projectSettings.detail.priority.low': 'Low',
  'projectSettings.detail.priority.medium': 'Medium',
  'projectSettings.detail.priority.high': 'High',
  'projectSettings.detail.priority.urgent': 'Urgent',
  'projectSettings.detail.logo': 'Project Logo URL',
  'projectSettings.detail.updatedAt': 'Last Updated',
  'projectSettings.detail.description': 'Project Description',
  'projectSettings.detail.empty': 'Not provided',
  'projectSettings.detail.editTitle': 'Edit Project Details',
  'projectSettings.detail.save': 'Save',
  'projectSettings.detail.cancel': 'Cancel',
  'projectSettings.detail.cnNameRequired': 'Enter the project name',
  'projectSettings.detail.identifierRequired': 'Enter the project identifier',
  'projectSettings.detail.identifierExists':
    'This project identifier already exists',
  'projectSettings.detail.saveSuccess': 'Project details updated',
  'projectSettings.detail.saveError':
    'Failed to update project details. Try again later.',
  'projectSettings.detail.previewHint':
    'You are previewing the project. Select Edit Project to make changes.',
  'projectSettings.detail.editingHint':
    'You are editing the project details. Save when you are finished.',
  'projectSettings.detail.discardTitle': 'Discard unsaved changes?',
  'projectSettings.detail.discardContent':
    'Your current changes have not been saved and cannot be recovered after leaving edit mode.',
  'projectSettings.detail.discard': 'Discard Changes',
  'projectSettings.detail.continueEditing': 'Continue Editing',
};
